export const SEARCH_INPUT_SUPPLIER_FILTER1_BUYER =
  'SEARCH_INPUT_SUPPLIER_FILTER1_BUYER'
export const SEARCH_OPTION_SUPPLIER_FILTER2_BUYER =
  'SEARCH_OPTION_SUPPLIER_FILTER2_BUYER'
export const SEARCH_OPTION_SUPPLIER_FILTER3_BUYER =
  'SEARCH_OPTION_SUPPLIER_FILTER3_BUYER'
export const SEARCH_OPTION_SUPPLIER_FILTER4_BUYER =
  'SEARCH_OPTION_SUPPLIER_FILTER4_BUYER'
